define('v3/Common/Services/Backend/extraInstructionBackend',[
	'jquery',
	'module',
	'BackendBase'
], function ($, module, BackendBase) {
	function ExtraInstructionBackend () {
		BackendBase.call(this);
	};

	ExtraInstructionBackend.prototype = $.extend({}, BackendBase.prototype);
	$.extend(ExtraInstructionBackend.prototype, {

		getNumberOfExtraInstructionsForSubdomains: function (subjectGroupId, pupilId) {
			return this._getJsonApiWithJwtAuthorization(this._getApiUrl('ExtraInstructions/NumberOfExtraInstructionsForSubdomains/' + subjectGroupId + '/' + pupilId));
		}
	});

	return new ExtraInstructionBackend();
});
